import { compact } from 'lodash'
import { ReportSection } from '../../../types'
import { ConfigSection, AnomalyReport } from '../../../../../shared/types'
import formatSummary from '../../summary/formatSummary'
import configureSummary from '../../summary/configureSummary'
import getAccountReportSection from './getAccountReportSection'
import getTransactionReportSection from './getTransactionReportSection'
import getVendorReportSection from './getVendorReportSection'
import getCustomerReportSection from './getCustomerReportSection'
import getUserReportSection from './getUserReportSection'
import getAnomalyReportSection from './getAnomalyReportSection'
import getAnomalyList from './getAnomalyList'

type Props = {
  report: AnomalyReport
  reportUrl?: string
  history: any
  location: any
  configSections?: ConfigSection[]
}

export default function getInsightReportSections(props: Props): ReportSection[] {
  const { report, reportUrl, history, location, configSections } = props
  const { reportMetadata } = report

  const formattedSummary = formatSummary(reportMetadata)

  const anomalyList = getAnomalyList({
    report,
    reportUrl,
    history,
    configSections,
  })

  //configure metadata based on anomaly details
  const { configuredAnomalies, configuredUserActivity } = configureSummary({
    summary: formattedSummary,
    reportSections: anomalyList,
    includeSeverity: true,
  })

  const transactionSection = getTransactionReportSection({
    formattedSummary,
    history,
    reportUrl,
    location,
  })

  const anomalySection = getAnomalyReportSection({
    configuredAnomalies,
    anomalyList,
    history,
    reportUrl,
  })

  const vendorSection = getVendorReportSection({
    formattedSummary,
    history,
    location,
    reportUrl,
  })

  const customerSection = getCustomerReportSection({
    formattedSummary,
    history,
    location,
    reportUrl,
  })

  const accountSection = getAccountReportSection({ formattedSummary, history, location, reportUrl })

  const userSection = getUserReportSection({
    formattedSummary,
    history,
    location,
    reportUrl,
    configuredUserActivity,
  })

  return compact([
    transactionSection,
    anomalySection,
    vendorSection,
    customerSection,
    accountSection,
    userSection,
  ])
}
